import { Seo } from "@/components/Seo";
import { BlogIsland, useBlogData } from "@/components/blog/BlogIsland";
import { BLOG_DATA, BLOG_DESCRIPTION, BLOG_TITLE, renderIndexIsland, type IndexData } from "@/lib/blog";

const isIndex = (d: unknown): d is IndexData => (d as IndexData | null)?.kind === "index" || (d as IndexData | null)?.kind === "error";

/**
 * Every published post. The list itself is written in Terradium and rendered
 * into this page by the Worker (worker/blog.ts), so a new post shows here
 * without a deploy.
 */
export default function Blog() {
  const data = useBlogData<IndexData>(`${BLOG_DATA}/posts`, isIndex, { kind: "error" });
  return (
    <main className="mx-auto max-w-5xl px-5 pt-28 pb-20 sm:px-8">
      <Seo title={BLOG_TITLE} description={BLOG_DESCRIPTION} path="/blog" />
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand">Blog</p>
      <h1 className="mt-2 text-4xl font-medium tracking-tight sm:text-5xl">Ruang kerja yang lebih baik.</h1>
      <p className="mt-4 max-w-2xl text-lg leading-relaxed text-ink/70">{BLOG_DESCRIPTION}</p>
      <BlogIsland className="mt-12" html={data && renderIndexIsland(data)} />
    </main>
  );
}
